import React, { useCallback, useEffect, useState } from 'react';
import { t } from 'i18next';
import { CloseIcon, Button } from 'components';
// import Phoneinput from 'components/Phoneinput';
import { useSelector, useDispatch } from 'react-redux';
import {
  // CountryCode,
  UpdateAuthData,
  MobileOtp,
  SendMailOtp,
} from 'redux/features/LoginSlice';
import { useNavigate } from 'react-router-dom';
import AutoComplete from 'components/AutoComplete';
import { domainOptions } from 'utils/helper';
import { mailformat } from 'utils/Constant';

const PasswordVerification = ({ handleChangeToPassword }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {authData} = useSelector((state) => state?.LoginReducer);

  const [isLoading, setIsLoading] = useState(false);
  const [inputChanges, setInputChanges] = useState();
  const [enableSubmit, setEnableSubmit] = useState(null);
  const [changeMobile, setChangeMobile] = useState(false);
  const [loginDetails, setLoginDetails] = useState({
    type: 'email',
    email: '',
    phone: '',
    phcode: '',
    code: '',
    sid: '',
    otpType: 'resetPassword',
  });
  const [errMsg, setErrmsg] = useState({
    email: '',
    phone: '',
    code: '',
  });

  // useEffect(() => {
  //   !countryCode?.country_calling_code && dispatch(CountryCode());
  // }, []);

  // useEffect(() => {
  //   setLoginDetails((prevState) => ({
  //     ...prevState,
  //     code: countryCode?.country_calling_code?.replace('+', ''),
  //   }));
  // }, [countryCode]);

  useEffect(() => {
    if (authData?.success) {
      setIsLoading(false);
      dispatch(UpdateAuthData(''));
      handleChangeToPassword(true);
    } else if (!authData?.success) {
      setIsLoading(false);
    }
  }, [authData]);

  useEffect(() => {
    if (enableSubmit !== null) {
      const validation = Object.keys(errMsg).every((it) => errMsg[it] === '');
      if (validation) {
        setIsLoading(true);
        if (loginDetails?.type === 'mobile') {
          loginDetails.phcode = '+' + loginDetails.code + loginDetails.phone;
          dispatch(MobileOtp(loginDetails, false));
        } else {
          dispatch(SendMailOtp(loginDetails, false));
        }
      }
    }
  }, [enableSubmit]);

  const handleChange = useCallback((data, name) => {
    setLoginDetails((prevState) => ({
      ...prevState,
      [name]: data,
    }));
  }, []);

  const handleValidation = () => {
    const validationParams = { ...errMsg };

    if (!changeMobile && loginDetails.email === '') {
      validationParams.email = t('Auth.emailreq');
    } else if (!changeMobile && !loginDetails.email.match(mailformat)) {
      validationParams.email = t('Auth.emailvalreq');
    } else validationParams.email = '';

    if (changeMobile && !loginDetails.phone) {
      validationParams.phone = t('Auth.phnonereq');
    } else {
      validationParams.phone = '';
    }

    setErrmsg(validationParams);
  };

  const handleSubmit = useCallback(() => {
    handleValidation();
    setEnableSubmit(!enableSubmit);
  }, [enableSubmit, handleValidation]);

  const onRightLabel = () => {
    setLoginDetails((prevState) => ({
      ...prevState,
      type: changeMobile ? 'mobile' : 'email',
    }));
    setChangeMobile(!changeMobile);
  };

  const isFormValid = () => {
    const { email, phone, code } = loginDetails;
    if (changeMobile) {
      return phone && code;
    } else {
      return email !== '';
    }
  };

  const handleInputChanges = (data, name) => {
    !data.includes('@') && setInputChanges(data);
    handleChange(data, name);
  };

  return (
    <>
      <div className="card-title">
        <CloseIcon
          iconType="back"
          customStyle="back_btn"
          onClick={() => navigate('/login')}
        />
        {t('Auth.ResetPassword')}
      </div>
      <div className="helper-title">{t('Auth.WeSendCode')}</div>
      <div className="inputbox">
        {!changeMobile && (
          <AutoComplete
            freeSolo
            Options={inputChanges ? domainOptions(inputChanges) : []}
            label={t('Auth.Email')}
            value={loginDetails.email}
            onChange={(data) => handleChange(data, 'email')}
            errMsg={errMsg.email}
            rightLabel={t('Auth.ResetWithPhone')}
            onRightLabel={onRightLabel}
            onInputChange={(_, newInputValue) =>
              handleInputChanges(newInputValue, 'email')
            }
          />
        )}
        {/* {changeMobile && (
          <Phoneinput
            label={t('Auth.Phone')}
            value={loginDetails.phone}
            onChange={(data) => handleChange(data, 'phone')}
            errMsg={errMsg.phone}
            rightLabel={t('Auth.ResetWithEmail')}
            onRightLabel={onRightLabel}
            code={loginDetails.code}
            CodeChange={(data) => handleChange(data, 'code')}
          />
        )} */}
      </div>
      <Button
        label={t('Auth.SendCode')}
        disabled={!isFormValid()}
        onClick={isFormValid() ? handleSubmit : () => {}}
        customStyles="auth-action-btn"
        loading={isLoading}
        loadingIndicator="Loading…"
      />
    </>
  );
};

export default PasswordVerification;
